export default __webpack_public_path__ + "static/media/main_logo_animation.34227b61.png";